import * as React from 'react';
import { AccountUpdateToastMessages } from '@/enums';
import { dismissModal } from '@/redux/modules/modal';
import { getHomeUrl } from '@/utils/urls';
import { getUiUpdateAccount, getUpdateAccountToastMessage } from '@/redux/modules/account/updateAccount/updateAccount';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { toast } from '@liveauctioneers/hammer-ui-core/toast';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useNavigate } from 'react-router-dom';
import AccountSettingsPage from './AccountSettingsPage';

const AccountSettingsPageContainer = () => {
    const dispatch = useAppDispatch();
    const { formatMessage } = useIntl();
    const toastMessage = useAppSelector(getUpdateAccountToastMessage);
    const { error: editProfileError } = useAppSelector(getUiUpdateAccount);
    const userLoggedIn = useAppSelector(isUserLoggedIn);
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!userLoggedIn) {
            navigate(getHomeUrl());
        }
    }, [userLoggedIn, navigate]);

    React.useEffect(() => {
        // if there is an error close the modal and scroll to the top so they can see the error.
        let timeout: ReturnType<typeof setTimeout>;
        if (editProfileError) {
            dispatch(dismissModal());
            timeout = setTimeout(() => window.scrollTo(0, 0), 250);
        }
        return () => clearTimeout(timeout);
    }, [dispatch, editProfileError]);

    React.useEffect(() => {
        if (toastMessage) {
            let messageEnum;
            switch (toastMessage) {
                case 'defaultUpdate':
                    messageEnum = AccountUpdateToastMessages.defaultUpdated;
                    break;
                default:
                    messageEnum = '';
                    break;
            }
            if (messageEnum) {
                toast('success', {
                    description: formatMessage({ id: messageEnum }),
                    title: formatMessage({
                        id: 'toastMessages.titles.success',
                    }),
                });
            }
        }
    }, [toastMessage, formatMessage]);

    return <AccountSettingsPage />;
};

export default AccountSettingsPageContainer;
